/**
 * @readonly
 * @enum {string}
 */
export const TpmsObjectClasses = Object.freeze({
    EQUIPMENT: 'EQUIPMENT',
    GENERIC: 'GENERIC',
    MACHINERY: 'MACHINERY',
    TRAILER: 'TRAILER',
    TRUCK: 'TRUCK',
    VEHICLE: 'VEHICLE'
})
